<template>
    <div class="bg-dark-create" :class="{ open: showmodal }"></div>
    <div class="user-details-page" :class="{ dark }">
        <div class="user-details-container">
            <Loader :isActive="hasLoaded" />

            <form v-if="hasLoaded" class="user-details-card" @submit.prevent="handleSubmit">
                <div class="profile-tabs" role="tablist">
                    <button
                        type="button"
                        class="profile-tab"
                        role="tab"
                        :class="{ 'is-active': profileTab === 'account' }"
                        :aria-selected="profileTab === 'account'"
                        @click="profileTab = 'account'"
                    >
                        {{ $t('student.profile.tabAccount') }}
                    </button>
                    <button
                        type="button"
                        class="profile-tab"
                        role="tab"
                        :class="{ 'is-active': profileTab === 'security' }"
                        :aria-selected="profileTab === 'security'"
                        @click="profileTab = 'security'"
                    >
                        {{ $t('student.profile.tabSecurity') }}
                    </button>
                    <button
                        type="button"
                        class="profile-tab"
                        role="tab"
                        :class="{ 'is-active': profileTab === 'courses' }"
                        :aria-selected="profileTab === 'courses'"
                        @click="profileTab = 'courses'"
                    >
                        {{ $t('student.profile.tabCourses') }}
                    </button>
                </div>

                <div v-show="profileTab === 'account'" class="profile-tab-panel">
                <section class="profile-section">
                    <div class="profile-avatar-wrapper">
                        <div class="profile-avatar">
                            <img
                                v-if="!userimagePreview && !userimage"
                                src="@/assets/user.png"
                                alt=""
                            />
                            <img
                                v-else
                                :src="userimagePreview ? userimagePreview : userimage"
                                alt=""
                            />
                            <label class="profile-avatar-edit" for="profile-photo-input" :aria-label="$t('student.profile.profileImage')">
                                <fa icon="fa-solid fa-pen" />
                            </label>
                        </div>
                    </div>
                    <div>
                        <span class="profile-upload-label">{{ $t('student.profile.profileImage') }}</span>
                        <div class="profile-upload-box">
                            <label class="profile-upload-drop" for="profile-photo-input">
                                <fa icon="fa-solid fa-image" />
                                <span>{{ $t('student.profile.selectImage') }}</span>
                                <small>{{ $t('student.profile.imageFormats') }}</small>
                            </label>
                            <div class="file-selector">
                                <label class="file-selector__button" for="profile-photo-input">
                                    <fa icon="fa-solid fa-image" />
                                    {{ $t('student.profile.chooseFile') }}
                                </label>
                                <span class="file-selector__name">
                                    {{ selectedFileName || $t('student.profile.noFileChosen') }}
                                </span>
                            </div>
                            <input
                                id="profile-photo-input"
                                class="profile-file-input"
                                type="file"
                                accept=".png, .jpg, .jpeg, .webp"
                                @change="updateFilePath"
                            />
                        </div>
                    </div>
                </section>

                <div class="user-form">
                    <div class="form-grid-2">
                        <div class="profile-field">
                            <label class="profile-field__label" for="profile-name">
                                {{ $t('common.name') }} <span class="profile-field__required">*</span>
                            </label>
                            <span class="profile-field__icon" aria-hidden="true"><fa icon="fa-solid fa-user" /></span>
                            <input id="profile-name" v-model="name" class="profile-input" type="text" />
                        </div>
                        <div class="profile-field">
                            <label class="profile-field__label" for="profile-email">
                                {{ $t('common.email') }} <span class="profile-field__required">*</span>
                            </label>
                            <span class="profile-field__icon" aria-hidden="true"><fa icon="fa-solid fa-envelope" /></span>
                            <input id="profile-email" v-model="email" class="profile-input" type="text" />
                        </div>
                    </div>

                    <div class="form-grid-3">
                        <div class="profile-field">
                            <label class="profile-field__label" for="profile-cpf">
                                {{ $t('student.profile.cpfPlaceholder') }} <span class="profile-field__required">*</span>
                            </label>
                            <span class="profile-field__icon" aria-hidden="true"><fa icon="fa-solid fa-id-card" /></span>
                            <input id="profile-cpf" v-model="cpf" class="profile-input" type="text" />
                        </div>
                        <div class="profile-field">
                            <label class="profile-field__label" for="profile-phone">
                                {{ $t('common.phone') }} <span class="profile-field__required">*</span>
                            </label>
                            <span class="profile-field__icon" aria-hidden="true"><fa icon="fa-solid fa-phone" /></span>
                            <input id="profile-phone" v-model="phone" class="profile-input" type="text" />
                        </div>
                        <div class="profile-field">
                            <label class="profile-field__label" for="profile-id-number">{{ $t('student.profile.idNumber') }}</label>
                            <span class="profile-field__icon" aria-hidden="true"><fa icon="fa-solid fa-id-card" /></span>
                            <input id="profile-id-number" v-model="idNumber" class="profile-input" type="text" />
                        </div>
                    </div>

                    <div class="address-row-main">
                        <div class="profile-field">
                            <label class="profile-field__label" for="profile-cep">{{ $t('student.profile.postcode') }}</label>
                            <span class="profile-field__icon" aria-hidden="true"><fa icon="fa-solid fa-map-pin" /></span>
                            <input id="profile-cep" v-model="cep" class="profile-input" type="text" />
                        </div>
                        <div class="profile-field">
                            <label class="profile-field__label" for="profile-address">{{ $t('student.profile.address') }}</label>
                            <span class="profile-field__icon" aria-hidden="true"><fa icon="fa-solid fa-house" /></span>
                            <input id="profile-address" v-model="address" class="profile-input" type="text" />
                        </div>
                        <div class="profile-field">
                            <label class="profile-field__label" for="profile-number">{{ $t('student.profile.number') }}</label>
                            <span class="profile-field__icon" aria-hidden="true"><fa icon="fa-solid fa-hashtag" /></span>
                            <input id="profile-number" v-model="number" class="profile-input" type="text" />
                        </div>
                    </div>

                    <div class="address-row-secondary">
                        <div class="profile-field">
                            <label class="profile-field__label" for="profile-complement">{{ $t('student.profile.addressComplement') }}</label>
                            <span class="profile-field__icon" aria-hidden="true"><fa icon="fa-solid fa-house" /></span>
                            <input
                                id="profile-complement"
                                v-model="addressComplement"
                                class="profile-input"
                                type="text"
                                :placeholder="$t('student.profile.complementPlaceholder')"
                            />
                        </div>
                        <div class="profile-field">
                            <label class="profile-field__label" for="profile-city">{{ $t('student.profile.city') }}</label>
                            <span class="profile-field__icon" aria-hidden="true"><fa icon="fa-solid fa-building" /></span>
                            <input id="profile-city" v-model="city" class="profile-input" type="text" />
                        </div>
                        <div class="profile-field">
                            <label class="profile-field__label" for="profile-state">{{ $t('student.profile.state') }}</label>
                            <span class="profile-field__icon" aria-hidden="true"><fa icon="fa-solid fa-map" /></span>
                            <select id="profile-state" v-model="county" class="profile-select">
                                <option disabled value="">{{ $t('student.profile.selectState') }}</option>
                                <option v-if="county && !states.includes(county)" :value="county">{{ county }}</option>
                                <option v-for="item in states" :key="item" :value="item">{{ item }}</option>
                            </select>
                            <fa class="profile-field__chevron" icon="fa-solid fa-chevron-down" />
                        </div>
                        <div class="profile-field">
                            <label class="profile-field__label" for="profile-country">{{ $t('student.profile.country') }}</label>
                            <span class="profile-field__icon" aria-hidden="true"><fa icon="fa-solid fa-globe" /></span>
                            <select id="profile-country" v-model="country" class="profile-select">
                                <option v-for="item in countries" :key="item.value" :value="item.value">{{ item.text }}</option>
                            </select>
                            <fa class="profile-field__chevron" icon="fa-solid fa-chevron-down" />
                        </div>
                    </div>

                    <div class="language-row">
                        <div class="profile-field">
                            <label class="profile-field__label" for="profile-language">{{ $t('common.language') }}</label>
                            <span class="profile-field__icon" aria-hidden="true"><fa icon="fa-solid fa-language" /></span>
                            <select
                                id="profile-language"
                                class="profile-select"
                                :value="currentLocale"
                                @change="onLocaleChange($event.target.value)"
                            >
                                <option v-for="item in localeOptions" :key="item.value" :value="item.value">{{ item.title }}</option>
                            </select>
                            <fa class="profile-field__chevron" icon="fa-solid fa-chevron-down" />
                        </div>
                    </div>

                    <div class="form-actions">
                        <button type="submit" class="update-profile-button">
                            <fa icon="fa-solid fa-floppy-disk" />
                            {{ $t('student.profile.updateProfile') }}
                        </button>
                    </div>
                </div>
                </div>

                <div v-show="profileTab === 'security'" class="profile-tab-panel user-form">
                    <section v-if="twoFactor" class="security-block two-factor-block">
                        <div class="two-factor-block__head">
                            <div class="two-factor-block__copy">
                                <h2 class="security-block__title">{{ $t('student.profile.twoFactorTitle') }}</h2>
                                <p class="security-block__hint">
                                    {{ twoFactor.companyRequired
                                        ? $t('student.profile.twoFactorCompanyRequired')
                                        : $t('student.profile.twoFactorHint') }}
                                </p>
                            </div>
                            <label class="two-factor-switch">
                                <input
                                    type="checkbox"
                                    :checked="twoFactor.enabled"
                                    :disabled="twoFactorBusy"
                                    @change="onTwoFactorChange"
                                />
                                <span class="two-factor-switch__track" aria-hidden="true"></span>
                                <span class="two-factor-switch__text">
                                    {{ twoFactor.enabled
                                        ? $t('student.profile.twoFactorOn')
                                        : $t('student.profile.twoFactorOff') }}
                                </span>
                            </label>
                        </div>
                        <div v-if="showMethodChoice" class="two-factor-block__methods">
                            <h3 class="two-factor-block__label">{{ $t('student.profile.twoFactorMethodLabel') }}</h3>
                            <p class="security-block__hint">
                                {{ twoFactor.companyRequired
                                    ? $t('student.profile.twoFactorMethodHint')
                                    : $t('student.profile.twoFactorMethodOwnHint') }}
                            </p>
                            <div class="two-factor-choices">
                                <label class="security-option" :class="{ 'is-selected': twoFactor.preferredMethod === 'email' }">
                                    <input
                                        type="radio"
                                        name="preferredMethod"
                                        value="email"
                                        :checked="twoFactor.preferredMethod === 'email'"
                                        :disabled="twoFactorBusy"
                                        @change="onPreferredMethod('email')"
                                    />
                                    <span>{{ $t('student.profile.twoFactorMethodEmail') }}</span>
                                </label>
                                <label class="security-option" :class="{ 'is-selected': twoFactor.preferredMethod === 'authenticator' }">
                                    <input
                                        type="radio"
                                        name="preferredMethod"
                                        value="authenticator"
                                        :checked="twoFactor.preferredMethod === 'authenticator'"
                                        :disabled="twoFactorBusy"
                                        @change="onPreferredMethod('authenticator')"
                                    />
                                    <span>{{ $t('student.profile.twoFactorMethodAuthenticator') }}</span>
                                </label>
                            </div>
                        </div>
                    </section>

                    <section class="security-block">
                        <h2 class="security-block__title">{{ $t('student.profile.changePassword') }}</h2>
                        <div class="password-grid">
                            <div class="profile-field">
                                <label class="profile-field__label" for="profile-current-password">{{ $t('student.profile.currentPassword') }}</label>
                                <span class="profile-field__icon" aria-hidden="true"><fa icon="fa-solid fa-lock" /></span>
                                <input
                                    id="profile-current-password"
                                    v-model="oldPassword"
                                    class="profile-input profile-input--password"
                                    :type="showCurrentPassword ? 'text' : 'password'"
                                    :placeholder="$t('student.profile.typeCurrentPassword')"
                                />
                                <button type="button" class="password-toggle" :aria-label="$t('student.profile.currentPassword')" @click="showCurrentPassword = !showCurrentPassword">
                                    <fa :icon="showCurrentPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'" />
                                </button>
                            </div>
                            <div class="profile-field">
                                <label class="profile-field__label" for="profile-new-password">{{ $t('student.profile.newPassword') }}</label>
                                <span class="profile-field__icon" aria-hidden="true"><fa icon="fa-solid fa-lock" /></span>
                                <input
                                    id="profile-new-password"
                                    v-model="password"
                                    class="profile-input profile-input--password"
                                    :type="showNewPassword ? 'text' : 'password'"
                                    :placeholder="$t('student.profile.typeNewPassword')"
                                />
                                <button type="button" class="password-toggle" :aria-label="$t('student.profile.newPassword')" @click="showNewPassword = !showNewPassword">
                                    <fa :icon="showNewPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'" />
                                </button>
                            </div>
                            <div class="profile-field">
                                <label class="profile-field__label" for="profile-confirm-password">{{ $t('student.profile.confirmNewPassword') }}</label>
                                <span class="profile-field__icon" aria-hidden="true"><fa icon="fa-solid fa-lock" /></span>
                                <input
                                    id="profile-confirm-password"
                                    v-model="rePassword"
                                    class="profile-input profile-input--password"
                                    :type="showConfirmPassword ? 'text' : 'password'"
                                    :placeholder="$t('student.profile.repeatNewPassword')"
                                />
                                <button type="button" class="password-toggle" :aria-label="$t('student.profile.confirmNewPassword')" @click="showConfirmPassword = !showConfirmPassword">
                                    <fa :icon="showConfirmPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'" />
                                </button>
                            </div>
                        </div>
                        <div class="security-actions">
                            <button type="button" class="update-profile-button" @click="changePassword">
                                <fa icon="fa-solid fa-floppy-disk" />
                                {{ $t('student.profile.updatePassword') }}
                            </button>
                        </div>
                    </section>
                </div>

                <div v-show="profileTab === 'courses'" class="profile-tab-panel student-access">
                    <section class="student-access__stats" :aria-label="$t('student.profile.coursesLinked')">
                        <article class="student-access__stat">
                            <span class="student-access__stat-icon" aria-hidden="true">
                                <fa icon="fa-book-open" />
                            </span>
                            <div class="student-access__stat-content">
                                <p class="student-access__stat-label">{{ $t('student.profile.coursesLinked') }}</p>
                                <p class="student-access__stat-value">{{ accessStats.linked }}</p>
                                <p class="student-access__stat-description">{{ $t('student.profile.coursesLinkedHint') }}</p>
                            </div>
                        </article>
                        <article class="student-access__stat">
                            <span class="student-access__stat-icon student-access__stat-icon--success" aria-hidden="true">
                                <fa icon="fa-circle-check" />
                            </span>
                            <div class="student-access__stat-content">
                                <p class="student-access__stat-label">{{ $t('student.profile.accessReleased') }}</p>
                                <p class="student-access__stat-value">{{ accessStats.released }}</p>
                                <p class="student-access__stat-description">{{ $t('student.profile.accessReleasedHint') }}</p>
                            </div>
                        </article>
                    </section>

                    <section class="student-access__card">
                        <header class="student-access__card-header">
                            <div>
                                <h2 class="student-access__section-title">{{ $t('student.profile.coursesLinked') }}</h2>
                                <p class="student-access__section-description">{{ $t('student.profile.coursesLinkedLead') }}</p>
                            </div>
                        </header>

                        <div class="student-access__filters">
                            <label class="student-access__search">
                                <fa icon="fa-magnifying-glass" />
                                <input
                                    v-model="accessSearch"
                                    type="search"
                                    :placeholder="$t('student.profile.searchCourse')"
                                />
                            </label>
                            <label class="student-access__sort">
                                <span>{{ $t('student.profile.sortBy') }}</span>
                                <select v-model="accessSort">
                                    <option value="recent">{{ $t('student.profile.sortRecent') }}</option>
                                    <option value="name">{{ $t('student.profile.sortName') }}</option>
                                </select>
                            </label>
                        </div>

                        <p v-if="coursesError" class="student-access__empty">{{ $t('student.profile.coursesLoadError') }}</p>
                        <div v-else-if="!accessRows.length" class="student-access__empty">
                            <strong>{{ $t('student.profile.coursesEmptyTitle') }}</strong>
                            <span>{{ $t('student.profile.coursesEmptyText') }}</span>
                        </div>
                        <div v-else-if="!filteredAccessRows.length" class="student-access__empty">
                            <strong>{{ $t('student.profile.coursesNoMatch') }}</strong>
                        </div>
                        <div v-else class="student-access__table-wrapper">
                            <table class="student-access__table">
                                <thead>
                                    <tr>
                                        <th>{{ $t('student.profile.colCourse') }}</th>
                                        <th>{{ $t('student.profile.colOrigin') }}</th>
                                        <th>{{ $t('student.profile.colRelease') }}</th>
                                        <th>{{ $t('student.profile.colAccess') }}</th>
                                        <th>{{ $t('student.profile.colProgress') }}</th>
                                        <th>{{ $t('student.profile.colActions') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in filteredAccessRows" :key="row.id">
                                        <td>
                                            <div class="student-access__course">
                                                <img
                                                    v-if="row.image"
                                                    class="student-access__course-image"
                                                    :src="row.image"
                                                    :alt="row.name"
                                                />
                                                <span v-else class="student-access__course-image student-access__course-image--empty" aria-hidden="true"></span>
                                                <div>
                                                    <p class="student-access__course-name">{{ row.name }}</p>
                                                    <p v-if="row.description" class="student-access__course-description">{{ row.description }}</p>
                                                </div>
                                            </div>
                                        </td>
                                        <td>{{ $t('student.profile.originUnavailable') }}</td>
                                        <td>{{ row.releaseLabel || '—' }}</td>
                                        <td>
                                            <span class="student-access__badge" :class="'is-' + row.access">
                                                {{ accessStatusLabel(row.access) }}
                                            </span>
                                        </td>
                                        <td>
                                            <div v-if="row.progress != null" class="student-access__progress-wrap">
                                                <span>{{ row.progress }}%</span>
                                                <div class="student-access__progress" aria-hidden="true">
                                                    <div class="student-access__progress-fill" :style="{ width: row.progress + '%' }"></div>
                                                </div>
                                            </div>
                                            <span v-else>{{ $t('student.profile.progressUnavailable') }}</span>
                                        </td>
                                        <td>
                                            <div class="student-access__menu">
                                                <button
                                                    type="button"
                                                    class="student-access__action"
                                                    :aria-label="$t('student.profile.moreActions')"
                                                    @click="toggleAccessMenu(row.id)"
                                                >
                                                    <fa icon="fa-ellipsis" />
                                                </button>
                                                <div v-if="openAccessMenuId === row.id" class="student-access__menu-list">
                                                    <button type="button" @click="openLinkedCourse(row)">
                                                        {{ $t('student.profile.viewCourse') }}
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>

                    <p class="finance-mock-note">{{ $t('student.profile.financeMockNote') }}</p>
                    <section class="student-access__card">
                        <header class="student-access__card-header">
                            <div>
                                <h2 class="student-access__section-title">{{ $t('student.profile.financeHistoryTitle') }}</h2>
                                <p class="student-access__section-description">{{ $t('student.profile.financeHistoryLead') }}</p>
                            </div>
                            <span class="student-access__count">{{ financeOrderCount }}</span>
                        </header>
                        <div class="student-access__table-wrapper">
                            <table class="student-access__table student-access__table--finance">
                                <thead>
                                    <tr>
                                        <th>{{ $t('student.profile.financeOrder') }}</th>
                                        <th>{{ $t('student.profile.financeCourse') }}</th>
                                        <th>{{ $t('student.profile.financeDate') }}</th>
                                        <th>{{ $t('student.profile.financeMethod') }}</th>
                                        <th>{{ $t('student.profile.financeAmount') }}</th>
                                        <th>{{ $t('student.profile.financeStatus') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="item in financePreview.purchases"
                                        :key="item.id"
                                        class="is-clickable"
                                        tabindex="0"
                                        @click="openFinancePurchase(item)"
                                        @keydown.enter="openFinancePurchase(item)"
                                    >
                                        <td>#{{ item.id }}</td>
                                        <td>{{ item.course }}</td>
                                        <td>{{ formatFinanceDate(item.date) }}</td>
                                        <td>{{ financeMethodLabel(item.method) }}</td>
                                        <td>{{ formatFinanceMoney(item.amount) }}</td>
                                        <td>
                                            <span class="finance-status" :class="'finance-status--' + item.status">
                                                {{ financeStatusLabel(item.status) }}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>
                </div>
            </form>

            <div
                v-if="selectedPurchase"
                class="finance-modal"
                role="presentation"
                @click.self="closeFinancePurchase"
            >
                <div
                    class="finance-modal__panel"
                    role="dialog"
                    aria-modal="true"
                    :aria-labelledby="'finance-purchase-' + selectedPurchase.id"
                    @keydown.esc="closeFinancePurchase"
                >
                    <header class="finance-modal__head">
                        <div>
                            <p class="finance-modal__kicker">#{{ selectedPurchase.id }}</p>
                            <h2 :id="'finance-purchase-' + selectedPurchase.id" class="finance-modal__title">
                                {{ selectedPurchase.course }}
                            </h2>
                        </div>
                        <button type="button" class="finance-modal__close" @click="closeFinancePurchase">
                            {{ $t('student.profile.financeClose') }}
                        </button>
                    </header>
                    <dl class="finance-meta finance-meta--modal">
                        <div>
                            <dt>{{ $t('student.profile.financeDate') }}</dt>
                            <dd>{{ formatFinanceDate(selectedPurchase.date) }}</dd>
                        </div>
                        <div>
                            <dt>{{ $t('student.profile.financeAmount') }}</dt>
                            <dd>{{ formatFinanceMoney(selectedPurchase.amount) }}</dd>
                        </div>
                        <div>
                            <dt>{{ $t('student.profile.financeMethod') }}</dt>
                            <dd>{{ financeMethodLabel(selectedPurchase.method) }}</dd>
                        </div>
                        <div>
                            <dt>{{ $t('student.profile.financeStatus') }}</dt>
                            <dd>
                                <span class="finance-status" :class="'finance-status--' + selectedPurchase.status">
                                    {{ financeStatusLabel(selectedPurchase.status) }}
                                </span>
                            </dd>
                        </div>
                        <div v-if="selectedPurchase.transaction">
                            <dt>{{ $t('student.profile.financeTransaction') }}</dt>
                            <dd>{{ selectedPurchase.transaction }}</dd>
                        </div>
                        <div v-if="selectedPurchase.method === 'card'">
                            <dt>{{ $t('student.profile.financeCard') }}</dt>
                            <dd>{{ selectedPurchase.brand }} •••• {{ selectedPurchase.last4 }}</dd>
                        </div>
                        <div v-if="selectedPurchase.holder">
                            <dt>{{ $t('student.profile.financeHolder') }}</dt>
                            <dd>{{ selectedPurchase.holder }}</dd>
                        </div>
                        <div v-if="selectedPurchase.expiry">
                            <dt>{{ $t('student.profile.financeExpires') }}</dt>
                            <dd>{{ selectedPurchase.expiry }}</dd>
                        </div>
                        <div v-if="selectedPurchase.installments">
                            <dt>{{ $t('student.profile.financeInstallments') }}</dt>
                            <dd>{{ selectedPurchase.installments }}x</dd>
                        </div>
                        <div v-if="selectedPurchase.pixCode" class="finance-meta__wide">
                            <dt>{{ $t('student.profile.financePixCode') }}</dt>
                            <dd>{{ selectedPurchase.pixCode }}</dd>
                        </div>
                        <div v-if="selectedPurchase.boletoLine" class="finance-meta__wide">
                            <dt>{{ $t('student.profile.financeBoletoLine') }}</dt>
                            <dd>{{ selectedPurchase.boletoLine }}</dd>
                        </div>
                    </dl>
                </div>
            </div>

            <v-dialog v-model="dialog" width="auto">
                <v-card
                    max-width="400"
                    prepend-icon="mdi-update"
                    :text="$t('student.profile.validationErrorText')"
                    :title="$t('student.profile.validationErrorTitle')"
                >
                    <template v-slot:actions>
                        <v-btn
                            class="ms-auto"
                            :text="$t('student.profile.ok')"
                            @click="dialog = false"
                        ></v-btn>
                    </template>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>
    <script>
        import { mapState } from 'vuex';
        import api from '@/utils/portal/user.js';
        import apiCourses from '@/utils/portal/course.js';
        import { courseCoverSrc } from '@/utils/courses';
        import { moduleTokenFromEnrol } from '@/utils/portal/courseToken';
        import securityApi from '@/utils/portal/security.js';
        import ApiCep from '@/utils/cep';
        import Loader from '@/components/Loader/loader.vue';
        import apiAWS from '@/utils/storage/aws';
        import { toast } from 'vue3-toastify';
        import { useTheme } from 'vuetify'
        import { setAppLocale } from '@/i18n';
        import { isRateLimited } from '@/utils/rateLimit';

        export default {
            data() {
                return {
                    windowHeight: window.innerHeight,
                    hasLoaded: false,
                    profileTab: 'account',
                    showmodal: '',
                    name: '',
                    email: '',
                    cpf: '',
                    phone: '',
                    cep: '',
                    address: '',
                    number: '',
                    logo: '',
                    city: '',
                    state: '',
                    country: '',
                    county: '',
                    password: '',
                    rePassword: '',
                    oldPassword: '',
                    idUser: null,
                    idNumber: null,
                    userimage: null,
                    userimagePreview: null,
                    selectedFileName: '',
                    showCurrentPassword: false,
                    showNewPassword: false,
                    showConfirmPassword: false,
                    addressComplement: '',
                    hasLoad: false,
                    dialog: false,
                    updatePassword: false,
                    twoFactor: null,
                    twoFactorBusy: false,
                    selectedPurchase: null,
                    linkedCourses: [],
                    coursesError: false,
                    accessSearch: '',
                    accessSort: 'recent',
                    openAccessMenuId: null,
                    financePreview: {
                        purchases: [
                            {
                                id: '62164',
                                course: 'Excel Avançado e Power BI',
                                date: '2026-10-23',
                                amount: 249.9,
                                method: 'pix',
                                status: 'pending',
                                transaction: 'tran_jMmeRykhOPU4QJgL',
                                pixCode: 'https://digital.mundipagg.com/pix/',
                            },
                            {
                                id: '61802',
                                course: 'Marketing Digital do Zero ao Avançado',
                                date: '2026-09-12',
                                amount: 179.9,
                                method: 'card',
                                status: 'paid',
                                transaction: 'tran_card_61802',
                                brand: 'Mastercard',
                                last4: '4421',
                                holder: 'Samuel Linkon',
                                expiry: '08/2028',
                                installments: 1,
                            },
                            {
                                id: '60110',
                                course: 'Gestão de Projeto e Liderança',
                                date: '2026-07-03',
                                amount: 199.9,
                                method: 'boleto',
                                status: 'paid',
                                transaction: 'tran_boleto_60110',
                                boletoLine: '23792.65602 90004.711496 35005.393703 7 74970000019990',
                            },
                        ],
                    },
                    brazilianStates: [
                        'Acre',
                        'Alagoas',
                        'Amapá',
                        'Amazonas',
                        'Bahia',
                        'Ceará',
                        'Distrito Federal',
                        'Espírito Santo',
                        'Goiás',
                        'Maranhão',
                        'Mato Grosso',
                        'Mato Grosso do Sul',
                        'Minas Gerais',
                        'Pará',
                        'Paraíba',
                        'Paraná',
                        'Pernambuco',
                        'Piauí',
                        'Rio de Janeiro',
                        'Rio Grande do Norte',
                        'Rio Grande do Sul',
                        'Rondônia',
                        'Roraima',
                        'Santa Catarina',
                        'São Paulo',
                        'Sergipe',
                        'Tocantins',
                    ],
                };
            },
            props: {
                show: Boolean,
                id: Number,
            },
            components: {
                Loader,
            },
            computed: {
                ...mapState(['token', 'dark', 'user']),
                minHeightStyle() {
                    return this.windowHeight + 'px'
                },
                states() {
                    return [...this.brazilianStates, this.$t('student.profile.others')];
                },
                countries() {
                    return [
                        { text: this.$t('student.profile.brazil'), value: 'br' },
                        { text: this.$t('student.profile.others'), value: 'outro' },
                    ];
                },
                currentLocale() {
                    const loc = this.$i18n.locale;
                    return loc && typeof loc === 'object' && 'value' in loc ? loc.value : loc;
                },
                localeOptions() {
                    return [
                        { title: this.$t('common.portuguese'), value: 'pt' },
                        { title: this.$t('common.english'), value: 'en' },
                        { title: this.$t('common.spanish'), value: 'es' },
                    ];
                },
                showMethodChoice() {
                    if (!this.twoFactor) return false;
                    if (this.twoFactor.canChooseMethod === true) return true;
                    return this.twoFactor.companyRequired !== true;
                },
                accessRows() {
                    return (this.linkedCourses || []).map((enrol) => this.normalizeAccessRow(enrol));
                },
                filteredAccessRows() {
                    const term = String(this.accessSearch || '').trim().toLowerCase();
                    let rows = this.accessRows;
                    if (term) {
                        rows = rows.filter((row) => (
                            row.name.toLowerCase().includes(term)
                            || String(row.description || '').toLowerCase().includes(term)
                        ));
                    }
                    const sorted = [...rows];
                    if (this.accessSort === 'name') {
                        sorted.sort((a, b) => a.name.localeCompare(b.name, 'pt', { sensitivity: 'base' }));
                    } else {
                        sorted.sort((a, b) => (b.releaseTime || 0) - (a.releaseTime || 0));
                    }
                    return sorted;
                },
                accessStats() {
                    const rows = this.accessRows;
                    return {
                        linked: rows.length,
                        released: rows.filter((row) => row.access === 'released').length,
                    };
                },
                financeOrderCount() {
                    const total = this.financePreview.purchases.length;
                    const key = total === 1
                        ? 'student.profile.financeOrderOne'
                        : 'student.profile.financeOrderMany';
                    return this.$t(key, { n: total });
                },
            },
            mounted() {
                this.updateHeight()
                window.addEventListener('resize', this.updateHeight)
            },
            beforeUnmount() {
                window.removeEventListener('resize', this.updateHeight)
            },
            methods: {
                onLocaleChange(value) {
                    if (value) setAppLocale(value);
                },
                updateHeight() {
                    this.windowHeight = window.innerHeight - 121
                    console.log(window.innerHeight)
                    console.log(this.windowHeight)
                },
                async getDataUser() {
                    this.hasLoaded = false;
                    try {
                        const [response, twoFactor] = await Promise.all([
                            api.getDataUser(this.token),
                            securityApi.getTwoFactor(this.token).catch((error) => {
                                console.error('Erro ao carregar 2FA do aluno', error);
                                return null;
                            }),
                        ]);
                        this.twoFactor = twoFactor;
                        this.name = response.name;
                        this.email = response.email;
                        this.cpf = response.socialNumber;
                        this.phone = response.phone;
                        this.cep = response.postcode;
                        this.type = response.type;
                        this.address = response.address;
                        this.number = response.addressNumber;
                        this.city = response.city;
                        this.state = response.county;
                        this.country = response.country ?? 'br'
                        this.county = response.county;
                        this.idNumber = response.idNumber;
                        this.addressComplement = response.addressComplement;
                        this.logo = response.photo || '';
                        this.userimage = response.photo || '';
                        this.userimagePreview = response.photoFinal || null;
                        this.hasLoaded = true;
                    } catch (error) {
                        console.error('Erro ao caregar dados de usuário', error);
                    }
                },
                async validateFields() {
                    if (
                        !this.name ||
                        !this.email ||
                        !this.cpf ||
                        !this.phone
                    ) {
                        this.dialog = true;
                        return false;
                    }
                    return true;
                },
                async editUser() {
                    const obj = {
                        name: this.name,
                        email: this.email,
                        phone: this.phone,
                        socialNumber: this.cpf,
                        idNumber: this.idNumber,
                        county: this.state,
                        country: this.country,
                        city: this.city,
                        address: this.address,
                        addressNumber: this.number,
                        addressComplement: this.addressComplement,
                        postcode: this.cep,
                        username: this.email,
                        type: this.type,
                        status: 1,
                        photo: this.logo,
                    };
                    try {
                        await api.EditUser(this.token, obj);
                        toast.success(this.$t('student.profile.profileUpdated'), { className: 'user-profile-toast' });
                    } catch (error) {
                        toast.error(this.$t('student.profile.editUserError'));
                        console.error('Erro ao editar o usuário', error);
                    }
                },
                closetab() {
                    this.hasLoaded = false;
                    this.showmodal = false;
                    this.updatePassword = false;
                    this.$emit('open-tab', this.showmodal);
                },
                opentab() {
                    (this.show = true), this.$emit('open-tab', this.showmodal);
                },
                async saveModule() {
                    // Não usado mais, lógica movida para handleSubmit
                },
                async putFileAws(url, file) {
                    try {
                        await apiAWS.putFileAWS(url, file);
                    } catch (error) {
                        console.error('Erro ao enviar arquivo para AWS');
                    }
                },
                async updateFilePath(event) {
                    const file = event.target.files[0];
                    if (!file) return;
                    this.selectedFileName = file.name;
                    this.userimagePreview = URL.createObjectURL(file);

                    try {
                        const response = await apiAWS.getSignatureImagePortal(
                            this.token,
                            file.name
                        );
                        await this.putFileAws(response.url, file);
                        this.logo = response.token;
                        this.userimage = response.token;
                    } catch (error) {
                        console.error('Erro na geração do TOKEN AWS');
                    }
                },
                async changePassword() {
                    if (!this.oldPassword || !this.password || !this.rePassword) {
                        toast.error(this.$t('student.profile.fillPasswordFields'));
                        return false;
                    }
                    if (this.password !== this.rePassword) {
                        toast.error(this.$t('student.profile.passwordsMustMatch'));
                        return false;
                    }
                    const obj = {
                        oldPassword: this.oldPassword,
                        newPassword: this.password,
                    };
                    try {
                        await api.changePassword(this.token, obj);
                        toast.success(this.$t('student.profile.passwordChanged'), { className: 'user-profile-toast' });
                        this.showmodal = false;
                        this.$emit('open-tab', this.showmodal);
                        // Limpa os campos de senha
                        this.oldPassword = '';
                        this.password = '';
                        this.rePassword = '';
                    } catch (error) {
                        toast.error(isRateLimited(error)
                            ? this.$t('auth.tooManyAttempts')
                            : this.$t('student.profile.passwordChangeError'));
                        console.error(error);
                    }
                },
                async getCEP() {
                    try {
                        const response = await ApiCep.getDataCep(this.cep);
                        console.debug(response);
                        this.city = response.city;
                        this.address = response.street;
                        const state = response.state;
                        if (this.brazilianStates.includes(state)) {
                            this.state = state;
                            this.country = 'br';
                        } else {
                            this.state = this.$t('student.profile.others');
                            this.country = 'outro';
                        }
                    } catch (error) {
                        console.error('Erro ao gerar dados do cep');
                    }
                },
                async onTwoFactorChange(event) {
                    if (!this.twoFactor || this.twoFactorBusy) return;
                    const enabled = event.target.checked;
                    const previous = { ...this.twoFactor };
                    this.twoFactorBusy = true;
                    try {
                        this.twoFactor = await securityApi.updateTwoFactor(this.token, enabled);
                        toast.success(this.$t('student.profile.twoFactorSaved'), { className: 'user-profile-toast' });
                    } catch (error) {
                        this.twoFactor = previous;
                        event.target.checked = previous.enabled;
                        toast.error(this.$t('student.profile.twoFactorSaveError'));
                        console.error('Erro ao atualizar 2FA do aluno', error);
                    } finally {
                        this.twoFactorBusy = false;
                    }
                },
                async onPreferredMethod(method) {
                    if (!this.showMethodChoice || this.twoFactorBusy) return;
                    if (method !== 'email' && method !== 'authenticator') return;
                    if (method === this.twoFactor.preferredMethod) return;
                    const previous = { ...this.twoFactor };
                    this.twoFactorBusy = true;
                    try {
                        if (this.twoFactor.enabled !== true && this.twoFactor.companyRequired !== true) {
                            await securityApi.updateTwoFactor(this.token, true);
                        }
                        this.twoFactor = await securityApi.updateTwoFactorMethod(this.token, method);
                        toast.success(this.$t('student.profile.twoFactorSaved'), { className: 'user-profile-toast' });
                    } catch (error) {
                        try {
                            this.twoFactor = await securityApi.getTwoFactor(this.token);
                        } catch (refreshError) {
                            this.twoFactor = previous;
                        }
                        toast.error(this.$t('student.profile.twoFactorSaveError'));
                        console.error('Erro ao escolher o método de 2FA', error);
                    } finally {
                        this.twoFactorBusy = false;
                    }
                },
                openFinancePurchase(item) {
                    this.selectedPurchase = item;
                },
                closeFinancePurchase() {
                    this.selectedPurchase = null;
                },
                async loadLinkedCourses() {
                    if (!this.token) return;
                    this.coursesError = false;
                    try {
                        const catalog = await apiCourses.getDataCourses(this.token, { page: 0, size: 100 });
                        this.linkedCourses = catalog.courses || [];
                    } catch (error) {
                        this.coursesError = true;
                        this.linkedCourses = [];
                        console.error('Erro ao carregar cursos do perfil', error);
                    }
                },
                normalizeAccessRow(enrol) {
                    const course = enrol?.course && typeof enrol.course === 'object' ? enrol.course : {};
                    const progressRaw = course.progressPercentage ?? enrol?.progressPercentage;
                    const progressNumber = progressRaw == null || progressRaw === '' ? null : Number(progressRaw);
                    const releaseRaw = course.dateEnrol || enrol?.dateEnrol || null;
                    const releaseDate = releaseRaw ? new Date(releaseRaw) : null;
                    const releaseTime = releaseDate && !Number.isNaN(releaseDate.getTime()) ? releaseDate.getTime() : 0;
                    return {
                        id: enrol?.id || course.id || course.name,
                        name: course.name || enrol?.name || '',
                        description: this.plainCourseText(course.shortDescription),
                        image: courseCoverSrc(course) || courseCoverSrc(enrol) || '',
                        releaseLabel: releaseTime ? this.formatAccessDate(releaseDate) : '',
                        releaseTime,
                        access: enrol?.locked ? 'blocked' : 'released',
                        progress: progressNumber == null || Number.isNaN(progressNumber)
                            ? null
                            : Math.min(100, Math.max(0, Math.round(progressNumber))),
                        enrol,
                    };
                },
                plainCourseText(value) {
                    if (value == null) return '';
                    const text = String(value).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
                    if (!text) return '';
                    return text.length > 140 ? `${text.slice(0, 137)}…` : text;
                },
                formatAccessDate(date) {
                    const locale = this.currentLocale || 'pt';
                    return date.toLocaleDateString(locale, {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                    });
                },
                accessStatusLabel(status) {
                    if (status === 'blocked') return this.$t('student.profile.accessBlocked');
                    return this.$t('student.profile.accessReleasedStatus');
                },
                toggleAccessMenu(id) {
                    this.openAccessMenuId = this.openAccessMenuId === id ? null : id;
                },
                openLinkedCourse(row) {
                    this.openAccessMenuId = null;
                    if (row.access === 'blocked') return;
                    const token = moduleTokenFromEnrol(row.enrol, this.user?.type);
                    if (!token || /^\d+$/.test(String(token))) return;
                    window.location.href = `/aluno/curso/${encodeURIComponent(token)}`;
                },
                financeMethodLabel(method) {
                    if (method === 'pix') return this.$t('student.profile.financePix');
                    if (method === 'boleto') return this.$t('student.profile.financeBoleto');
                    if (method === 'free') return this.$t('student.profile.financeFree');
                    return this.$t('student.profile.financeCard');
                },
                financeStatusLabel(status) {
                    if (status === 'paid') return this.$t('student.profile.financePaid');
                    if (status === 'failed') return this.$t('student.profile.financeFailed');
                    if (status === 'refunded') return this.$t('student.profile.financeRefunded');
                    return this.$t('student.profile.financePending');
                },
                formatFinanceMoney(value) {
                    return Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                },
                formatFinanceDate(value) {
                    if (!value) return '';
                    const [year, month, day] = String(value).split('-');
                    if (!year || !month || !day) return value;
                    return `${day}/${month}/${year}`;
                },
                async handleSubmit() {
                    const valid = await this.validateFields();
                    if (!valid) return;
                    await this.editUser();
                    this.showmodal = false;
                    this.$emit('open-tab', this.showmodal);
                },
                dark: {
                     immediate: true,
                        handler(val) {
                            const theme = useTheme()
                            theme.global.name.value = val ? 'dark' : 'light'
                        }
                }
            },
            created() {
                this.getDataUser();
                this.loadLinkedCourses();
            },

            watch: {
                show(novoValor) {
                    this.showmodal = this.show;
                    this.idUser = this.id;
                    this.getDataUser();
                },
            },
        };
    </script>
    <style src="./css/user-profile.css"></style>
